import components from '../components';
import TitreBandeauController from './titre-bandeau.controller';
import TitreBandeauTemplate from './titre-bandeau.template.html';

components
  .component('titreBandeau', {
    bindings: {
      comment: '@'
    },
    controller: TitreBandeauController,
    template: TitreBandeauTemplate
  });



// WEBPACK FOOTER //
// ./src/app/components/titre-bandeau/titre-bandeau.component.js